<template>
  <main-container>
    <a-card>
      <a-form-model
        ref="createFormRef"
        layout="horizontal"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
        :model="createForm"
        :rules="createFormRules"
      >
        <a-form-model-item label="分类" prop="type">
          <a-select placeholder="请选择" :options="selectOptions" v-model="createForm.type"></a-select>
        </a-form-model-item>
        <a-form-model-item label="标题" prop="title">
          <a-input :placeholder="`请输入标题`" v-model="createForm.title"></a-input>
        </a-form-model-item>
        <a-form-model-item label="宣传图">
          <upload
            tooltip="上传jpg/png文件，且不超过6M"
            accept=".png,.jpeg,.jpg"
            :max-length="1"
            :max-size="6 * 1024 * 1024"
            :file-list="fileList"
            @change="handleUploadChange"
          ></upload>
        </a-form-model-item>
        <a-form-model-item label="内容" prop="content">
          <ckeditor @ready="onReady" :editor="editor" :config="editorConfig" v-model="createForm.content"></ckeditor>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 6 }">
          <a-button @click="submit" type="primary">
            提交
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </main-container>
</template>

<script>
import '@ckeditor/ckeditor5-build-classic/build/translations/zh-cn';

import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Article from '@/api/article';
import MyUploadAdapter from '@/components/common/MyUploadAdapter.js';
import Upload from '@/components/common/Upload';
import { getFileByPath } from '@/utils';

export default {
  name: 'SettingMember',
  data() {
    return {
      createForm: {
        type: undefined,
        title: undefined,
        cover: undefined,
        content: undefined,
      },
      createFormRules: {
        type: [
          {
            required: true,
            message: '分类为必选项',
          },
        ],
        title: [
          {
            required: true,
            message: '标题为必填项',
          },
        ],
        content: [
          {
            required: true,
            message: '内容为必填',
          },
        ],
      },
      editor: ClassicEditor,
      editorConfig: {
        language: 'zh-cn',
        toolbar: {
          shouldNotGroupWhenFull: true,
        },
      },
      selectOptions: [
        {
          key: 1,
          label: '服务条款',
        },
        {
          key: 2,
          label: '帮助中心',
        },
        {
          key: 3,
          label: '上门取件说明',
        },
      ],
      fileList: [],
    };
  },

  computed: {
    isUpdate() {
      return this.$route.query.id && this.$route.params.id;
    },
  },

  created() {
    this.createForm.type = parseInt(this.$route.query.type);
    if (this.$route.query.id && !this.$route.params.id) {
      this.$router.push({
        name: this.$routeName.articleSetting,
      });
    }

    if (this.$route.query.id && this.$route.params.id) {
      const { id, title, type, content, cover } = this.$route.params;
      this.createForm = { id, title, type: parseInt(type), cover, content };
      this.fileList = this.$route.params.cover ? [getFileByPath(this.$route.params.cover)] : [];
    }
  },

  components: {
    Upload,
  },

  methods: {
    onReady(editor) {
      // 自定义上传图片插件
      editor.plugins.get('FileRepository').createUploadAdapter = loader => {
        return new MyUploadAdapter(loader);
      };
    },

    handleUploadChange({ fileList, path }) {
      this.fileList = fileList;
      this.createForm.cover = path;
    },

    submit() {
      this.$refs.createFormRef.validate(valid => {
        if (!valid) {
          return false;
        } else {
          this.isUpdate ? this.updateArticle() : this.createArticle();
        }
      });
    },

    updateArticle() {
      Article.Copywritingupdate(this.createForm).then(res => {
        if (res.status == 'success') {
          this.$message.success('更新成功');
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        }
      });
    },

    createArticle() {
      Article.AddCopywriting(this.createForm).then(res => {
        if (res.status == 'success') {
          this.$message.success('新增成功');
          setTimeout(() => {
            this.$router.back();
          }, 1000);
        }
      });
    },
  },
};
</script>

<style scoped></style>
